'use client'

import { useTranslations } from 'next-intl'

import SuccessIcon from '@/assets/icons/success.svg'
import Dialog from '@/shared/ui/Dialog'

import S from '../ClubModeration.module.scss'

type SupportModalProps = {
  open: boolean
  onClose: () => void
  message: string
  onMessageChange: (value: string) => void
  onSubmit: (message: string) => void
  isPending: boolean
  submitted: boolean
}

export function SupportModal({
  open,
  onClose,
  message,
  onMessageChange,
  onSubmit,
  isPending,
  submitted
}: SupportModalProps) {
  const t = useTranslations('clubs.moderation')

  return (
    <Dialog
      open={open}
      toggle={open => !open && onClose()}
      title={submitted ? undefined : t('supportModal.title')}
      className={S.supportModal}
      description="Contact support about your club moderation"
    >
      {submitted ? (
        <div className={S.supportModalSuccess}>
          <SuccessIcon className={S.supportModalSuccessIcon} aria-hidden />
          <h3 className={S.supportModalSuccessTitle}>
            {t('supportModal.successTitle')}
          </h3>
          <p className={S.supportModalSuccessDescription}>
            {t('supportModal.successDescription')}
          </p>
          <button
            type="button"
            className={S.supportModalSubmit}
            onClick={onClose}
          >
            {t('supportModal.successClose')}
          </button>
        </div>
      ) : (
        <>
          <p className={S.supportModalSubtitle}>{t('supportModal.subtitle')}</p>
          <form
            className={S.supportModalForm}
            onSubmit={e => {
              e.preventDefault()
              const msg = message.trim()
              if (!msg) {
                return
              }
              onSubmit(msg)
            }}
          >
            <div className={S.supportModalTextareaWrap}>
              <textarea
                className={S.supportModalTextarea}
                value={message}
                onChange={e => onMessageChange(e.target.value)}
                placeholder={t('supportModal.messagePlaceholder')}
                rows={4}
                required
              />
            </div>
            <div className={S.supportModalActions}>
              <button
                type="submit"
                className={S.supportModalSubmit}
                disabled={isPending || !message.trim()}
              >
                {isPending
                  ? t('supportModal.sending')
                  : t('supportModal.submit')}
              </button>
              <button
                type="button"
                className={S.supportModalCancel}
                onClick={onClose}
              >
                {t('supportModal.cancel')}
              </button>
            </div>
          </form>
        </>
      )}
    </Dialog>
  )
}
